import React, { useCallback, useState } from "react";

import { MenuItem, SelectChangeEvent } from "@mui/material";
import { useTranslation } from "react-i18next";

import { useOrderContext } from "Hooks/useOrderContext";
import { ItemStatus } from "Models/item.status";
import { ItemJobStatus } from "Util/enums";
import { isEnableBOL } from "Util/isEnableBOL";
import ConfirmationModal from "Components/Dialogs/ConfirmationModal";
import Select from "Components/Form/Select";

interface Props {
  open: boolean;
  itemStatus?: ItemStatus[];
  onClose: () => void;
  onChange: (status: string) => void;
}

const ChangeItemStatusModal = ({ open, itemStatus, onClose, onChange }: Props) => {
  const { t: translate } = useTranslation();

  const [statusSelected, setStatusSelected] = useState<string>("");

  const { order } = useOrderContext();

  const checkEnableBOL = useCallback(() => isEnableBOL(order), [order?.tasks]);

  const handleChangeStatusTo = () => {
    onChange(statusSelected);
  };

  const handleCloseModal = () => {
    setStatusSelected("");
    onClose();
  };

  return (
    <ConfirmationModal
      title={translate("changeItemStatuses")}
      open={open}
      closeModal={handleCloseModal}
      submit={handleChangeStatusTo}
      saveDisabled={statusSelected === ""}
    >
      <Select
        label={translate("changeAllSelectedItemsStatusesTo")}
        name="changeStatuses"
        value={statusSelected}
        onChange={(event: SelectChangeEvent<any>) => setStatusSelected(event.target.value)}
        placeholder={translate("selectAnOption")}
        data-cy="status-select"
      >
        {itemStatus &&
          itemStatus?.map((statusValue: ItemStatus) => {
            let disabled: boolean = false;

            if (
              statusValue?.name?.toLowerCase() === ItemJobStatus.BOL.toLowerCase() &&
              !checkEnableBOL()
            ) {
              disabled = true;
            }

            if (
              [
                ItemJobStatus.TRANSSHIPPED.toLowerCase(),
                ItemJobStatus.NOT_SIGHTED.toLowerCase(),
              ].includes(statusValue?.name?.toLowerCase())
            ) {
              disabled = true;
            }

            return (
              <MenuItem disabled={disabled} key={statusValue.id} value={statusValue.name}>
                {statusValue.name}
              </MenuItem>
            );
          })}
      </Select>
    </ConfirmationModal>
  );
};

export default ChangeItemStatusModal;
